import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { Col, Row, Title, VerticalSeparator } from "../../../style/base.style";
import { Colors } from "../../../style/colors";
import { useDeviceType } from "../../../contexts/DeviceContext";

interface PopupProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children?: React.ReactNode;
}

export const PopupLayout = ({ isOpen, onClose,title,children }:PopupProps) => {
    const {isMobile} = useDeviceType();
    
    if (!isOpen) return null;

  

  // Select the predefined container
  const container = document.getElementById("popup-container") as HTMLElement;

  return ReactDOM.createPortal(
    <PopupContainer>
      <Col style={{maxWidth:"450px"}} $gap={10} $backgroundColor={Colors.whiteBackground} $padding="20px" $borderRadius="10px"  $width={isMobile?"90%":"50%"} $justifyContent="flex-start" $alignItems="center">
      <Row $width="100%" $justifyContent="space-between">
        <Col $width="30px">
        <CloseButton onClick={onClose}>✕</CloseButton>
        </Col>
        <Col>
        <Title $fontSize={24}>{title}</Title>
        </Col>
        <Col $width="30px">
        </Col>
      
      
      </Row>
       
        
        <VerticalSeparator/>
        {children}
      
        </Col>  
    
    </PopupContainer>
      ,
    container
  );
};

const PopupContainer  = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.274);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
   
`;

const CloseButton = styled.button`

    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #465D7C;
    color: #FFF;
    box-shadow: none;
    font-size: 14px;
    display: flex
;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
    justify-content: center;
    -webkit-justify-content: center;
    padding: 0;
    opacity: 1;
    border: none;

    &:hover {
        background: red; /* Highlight effect */
    }

`
